// deps
import { useContext, useMemo } from "react";

// contexts
import { CartOverlaysContext } from "@swiggy-private/checkout-core";

// helpers
import { shouldRenderLottie } from "@cart-client/helpers/Overlay";

export const useShouldRenderLottie = (): boolean => {
    const { enabledOverlayType, enabledOverlayId } = useContext(CartOverlaysContext);

    const canRenderLottie = useMemo(
        () => shouldRenderLottie(enabledOverlayType, enabledOverlayId),
        [enabledOverlayType, enabledOverlayId],
    );

    return canRenderLottie;
};
